import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core/styles';

export const useSetupDialogStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogPaper: {
      borderRadius: 8,
      maxWidth: 700,
      minHeight: 500,
    },
    header: {
      padding: '24px 24px 16px 24px',
      position: 'relative',
    },
    closeButton: {
      position: 'absolute',
      top: 16,
      right: 16,
      color: theme.palette.text.secondary,
    },
    title: {
      fontWeight: 700,
      fontSize: 20,
      letterSpacing: '-0.02em',
      color: '#343434',
      paddingRight: 40,
    },
    subtitle: {
      color: '#545454',
      marginTop: 4,
      fontSize: 14,
    },
    content: {
      padding: '0 24px 24px 24px',
    },
    description: {
      color: theme.palette.text.secondary,
      fontSize: 14,
      marginBottom: 16,
    },
    // Section title (e.g. "Upload documents")
    sectionTitle: {
      fontWeight: 600,
      fontSize: 14,
      color: '#343434',
      marginBottom: 12,
      marginTop: 8,
    },
    actions: {
      padding: '16px 24px 24px 24px',
      justifyContent: 'space-between',
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    secondaryButton: {
      color: theme.palette.text.secondary,
      textTransform: 'none',
      fontWeight: 500,
      fontSize: 14,
    },
    primaryButton: {
      backgroundColor: '#796fff',
      color: '#ffffff',
      textTransform: 'none',
      fontWeight: 600,
      fontSize: 14,
      padding: '8px 20px',
      borderRadius: 6,
      '&:hover': {
        backgroundColor: '#635ac7',
      },
      '&:disabled': {
        backgroundColor: theme.palette.grey[300],
        color: theme.palette.grey[500],
      },
    },
    // Upload step styles
    uploadSection: {
      marginBottom: 24,
    },
    // Results step styles
    resultsContainer: {
      maxHeight: 400,
      overflowY: 'auto',
    },
    summaryBox: {
      backgroundColor: theme.palette.grey[50],
      borderRadius: 8,
      padding: 16,
      marginBottom: 24,
    },
    summaryIcon: {
      color: '#4caf50',
      marginRight: 8,
    },
    summaryTitle: {
      fontWeight: 600,
      fontSize: 15,
    },
    summaryText: {
      color: theme.palette.text.secondary,
      fontSize: 14,
      marginTop: 4,
    },
    resultSection: {
      marginBottom: 24,
    },
    resultSectionTitle: {
      fontWeight: 600,
      fontSize: 14,
      marginBottom: 12,
      display: 'flex',
      alignItems: 'center',
    },
    resultSectionIcon: {
      marginRight: 8,
      fontSize: 20,
      color: '#796fff',
    },
    itemCard: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 8,
      padding: 12,
      marginBottom: 8,
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: theme.palette.grey[50],
        borderColor: theme.palette.grey[300],
      },
    },
    itemCardSelected: {
      backgroundColor: 'rgba(121, 111, 255, 0.06)',
      borderColor: 'rgba(121, 111, 255, 0.4)',
    },
    itemCardUnselected: {
      opacity: 0.6,
    },
    itemName: {
      fontWeight: 600,
      fontSize: 14,
      color: theme.palette.text.primary,
    },
    itemDescription: {
      color: theme.palette.text.secondary,
      fontSize: 13,
      marginTop: 2,
    },
    itemReason: {
      color: theme.palette.text.disabled,
      fontSize: 12,
      marginTop: 4,
      fontStyle: 'italic',
    },
    // Processing/Complete/Error views
    centeredView: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 300,
      textAlign: 'center',
    },
    centeredIcon: {
      fontSize: 64,
      marginBottom: 16,
    },
    centeredTitle: {
      fontWeight: 600,
      fontSize: 18,
      color: theme.palette.text.primary,
      marginBottom: 8,
    },
    centeredSubtitle: {
      color: theme.palette.text.secondary,
      fontSize: 14,
    },
  })
);
